import React, { useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { Button } from 'primereact/button'
import InputMask from 'react-input-mask'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import { formatCNPJ, validCnpj, validCpf } from './validacoes'
import { Toast } from 'primereact/toast'
import jwt_decode from 'jwt-decode'
import ButtonReenviarToken from './ButtonReenviarToken'

const Login = (props) => {
  const [carregandoResquest, setCarregandoRequest] = useState(false)
  const [errorLogin, setErrorLogin] = useState('')
  const [login, setLogin] = useState('')
  const [senha, setSenha] = useState('')
  const [ctrl, setCtrl] = useState(1)
  const [lastCharIs, setLastCharIs] = useState('')

  var buff
  const toast = useRef()

  const saveBuff = function (event) {
    buff = event.key
  }

  const handleOnSubmit = async function (e) {
    e.preventDefault()

    const usuarioServiceAPI = new UsuarioServiceAPI()

    try {
      setCarregandoRequest(true)
      const res = await usuarioServiceAPI.logarUsuario(login, senha)

      toast.current.show({
        severity: 'success',
        summary: 'Sucesso',
        detail: 'Login realizado com sucesso, você será redirecionado em breve',
        life: 3000,
      })

      localStorage.setItem('@token', res?.data?.token)
      localStorage.setItem('@authorities', JSON.stringify(['ALL']))
      localStorage.setItem(
        '@usuario',
        JSON.stringify({
          nome_completo: res.data?.user?.nome,
          empresa: 'KSK',
        })
      )
      setTimeout(() => {
        window.location.reload()
      }, 3000)
    } catch (ex) {
      toast.current.show({
        severity: 'error',
        summary: 'Tente novamente',
        detail: 'Houve um erro inesperado, tente novamente',
        life: 3000,
      })
      setCarregandoRequest(false)
      localStorage.clear()
    }
  }

  return (
    <div
      className='login-body'
      style={{
        height: '100vh',
        overflow: 'hidden',
        // backgroundColor: '#F2F2F2',
      }}
    >
      <div className='hidden lg:inline'>
        {/* <img
                    src={`assets/layout/images/pages/login-${
                        props.colorScheme === "light" ? "ondark" : "onlight"
                    }.png`}
                    alt="atlantis"
                /> */}
      </div>
      <div className='login-panel p-fluid'>
        <div className='flex flex-column'>
          <form onSubmit={handleOnSubmit}>
            <Toast ref={toast} />
            <div className='flex align-items-center mb-6 logo-container just'>
              <img
                src={`assets/images/logo.png`}
                style={{ maxWidth: 250 }}
                className='w-full'
                alt='login-logo'
              />
              {/* <img
                src={`assets/images/logo-maxtool.svg`}
                className='login-appname'
                alt='login-appname'
              /> */}
            </div>
            <div className='form-container'>
              <span className='p-input-icon-left'>
                <i className='pi pi-user'></i>
                <InputText
                  value={login}
                  onChange={(e) => setLogin(e.target.value)}
                  required
                  type='email'
                  placeholder='E-mail'
                />
              </span>
              {errorLogin && (
                <div className='p-error mb-2' style={{ textAlign: 'left' }}>
                  <small>CPF ou CNPJ Inválido</small>
                </div>
              )}
              <span className='p-input-icon-left'>
                <i className='pi pi-key'></i>
                <InputText
                  value={senha}
                  onChange={(e) => setSenha(e.target.value)}
                  required
                  type='password'
                  placeholder='Senha de acesso'
                />
              </span>
            </div>
            <div className='button-container'>
              <Button
                loading={carregandoResquest}
                type='submit'
                label='Login'
              ></Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login
